import type { CarrierModuleState, CarrierSchool } from "../types";

// Gemeinsame Bausteine der Träger-Seiten

export { esc } from "../utils/html";

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "" : d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatNumber(n: number | null | undefined): string {
  return n == null ? "k. A." : n.toLocaleString("de-DE");
}

/** Badges „Eigene Schule“ und „Stammschule“ */
export function schoolBadges(s: Pick<CarrierSchool, "isOwnSchool" | "isFoundingSchool">): string {
  return [
    s.isOwnSchool ? `<span class="badge badge-green">Eigene Schule</span>` : "",
    s.isFoundingSchool ? `<span class="badge badge-purple" title="Die Schule, aus der der Schulträger erstellt wurde">Stammschule</span>` : "",
  ].join(" ");
}

/** Zähler offener Anfragen am Menüpunkt „Schulen“ setzen oder entfernen. */
export function setRequestCount(count: number): void {
  const link = document.querySelector<HTMLElement>('.nav-link[data-route="traeger-schulen"]');
  if (!link) return;
  link.querySelector(".nav-count")?.remove();
  if (count > 0) link.insertAdjacentHTML("beforeend", `<span class="nav-count" title="Offene Anfragen zum Verbinden">${count}</span>`);
}

export const MODULE_LABELS: Record<string, string> = {
  planung: "Planung",
  schuelerPortal: "Schüler-Portal",
  stundenplan: "Stundenplan",
};

/** Kurzstatus eines Moduls als Badge für eine Tabellenzelle: gebucht, freigeschaltet, Test bis oder nicht freigeschaltet. */
export function moduleBadge(st: CarrierModuleState | null | undefined): string {
  if (!st) return `<span class="badge badge-gray">unbekannt</span>`;
  if (st.paid) return `<span class="badge badge-green">gebucht</span>`;
  if (st.manualGrant) return `<span class="badge badge-green">freigeschaltet</span>`;
  if (st.trialActive) return `<span class="badge badge-amber">${st.trialEndsAt ? `Test bis ${formatDate(st.trialEndsAt)}` : "Testphase"}</span>`;
  return `<span class="badge badge-gray">nicht freigeschaltet</span>`;
}
